export default __webpack_public_path__ + "static/individual.eglo-66341b2cfc0c4ab70ad19eae81077133.webp";